import Vue from "vue";
import Vuex from "vuex";

import mess from "@/store/mess";
import companies from "@/store/companies";
import breadcrumbs from "@/store/breadcrumbs";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    mess,
    companies,
    breadcrumbs
  }
});
